import React, { useState, useEffect } from 'react'
import moment from 'moment'
import HaulLoads from './HaulLoads'

const Hauls = props => {
  const [viewingLoads, setViewingLoads] = useState(false)
  const [currentHaulLoads, setCurrentHaulLoads] = useState()
  const [currentHaulName, setCurrentHaulName] = useState()
  const [currentProjectName, setCurrentProjectName] = useState()

  const handleHaulPress = (haulId, project) => {
    setViewingLoads(true)
    setCurrentHaulLoads(props.activeNow.activeData.filter(item => item.haulId === haulId))
    setCurrentHaulName(haulId)
    setCurrentProjectName(project)
    props.history.push(`/app/active/hauls/loads/`)
  }

  useEffect(() => {
    if (props.location.pathname === '/app/active/hauls') {
      setViewingLoads(false)
      setCurrentHaulLoads(null)
      setCurrentHaulName(null)
      setCurrentProjectName(null)
    }
  }, [props.location.pathname])

  return viewingLoads ? (
    <div style={{ margin: '16px' }}>
      <HaulLoads
        activeData={props.activeNow.activeData}
        currentHaulLoads={currentHaulLoads}
        currentHaulName={currentHaulName}
        currentProjectName={currentProjectName}
      />
    </div>
  ) : (
    <div style={{ margin: '16px' }}>
      <div>
        <span style={{ ccoclor: '#6B6C70', fontSize: '16px' }}>Active Now</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0 36px' }}>
        <span style={{ fontSize: '24px', color: '#3E3F42', fontWeight: '500' }}>
          {props.activeNow.hauls.length + (props.activeNow.hauls.length === 1 ? ' Haul' : ' Hauls')}
        </span>
        <span style={{ fontSize: '12px', alignSelf: 'flex-end' }}>
          Last updated {moment().format('HH:mm')}
        </span>
      </div>

      <div>
        {props.activeNow.hauls.map((haul, i) => {
          const loads = props.activeNow.activeData.filter(data => data.haulId === haul).length
          const trucks = props.activeNow.signOnOffData.filter(item => item.haulId === haul).length
          const project = props.activeNow.signOnOffData.find(item => item.haulId === haul)
            .projectName
          return (
            <div
              key={i}
              style={{
                height: '92px',
                boxShadow: '0px 1px 3px #00000029',
                borderRadius: '5px',
                marginTop: i > 0 ? '16px' : null
              }}
              onClick={() => handleHaulPress(haul, project)}
            >
              <div
                style={{
                  backgroundColor: '#F6F9FD',
                  height: '35px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontSize: '16px', color: '#3E3E41', paddingLeft: '16px' }}>
                  {haul}
                </span>
              </div>
              <div style={{ display: 'flex', height: '52px' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '20%',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    borderRight: '1px solid #E7E7EC',
                    marginTop: '5px'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Loads</span>
                  <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                    {loads}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '20%',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    borderRight: '1px solid #E7E7EC',
                    marginTop: '5px'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Trucks</span>
                  <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                    {trucks}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    marginTop: '5px',
                    width: '50%'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Project</span>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-end'
                    }}
                  >
                    <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                      {project}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Hauls
